<template>
  <div class="mentor_mentee_lists">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu />

      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Mentors/Mentees</h3>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>

          <div class="margin-bottom-10"></div>
          <div class="text-align-center col-12">
            <input type="search" name="search" size="20" placeholder="Search By Account Name" class="col-12 col-md-12 col-lg-12 input-height-25" style="float: none;" ref='search' v-model="search"/>
          </div>
          <div style="clear: both;"></div>
          <div class="margin-bottom-10"></div>
          <div v-if="userslist.length > 0">
            <div v-for="account, account_index in userslist" v-if="account.groups.length > 0" class="col-xs-12 col-md-6 col-lg-4 col-xl-3 account_main_class padding-lr-5">
              <div class="account_class">
                <div class="bold account_name">{{ account.account_name }}</div>
                <div class="margin-bottom-10"></div>

                <div class="group_class" v-for="group,group_index in account.groups" v-if="group_index == 0">
                  <div class="margin-left-10" >
                      <div class="font-12 bold input-height-20 group_name"><i class="fa fa-group"></i> Group: {{ group.group_name }}</div>
                      <div class="font-12 margin-left-10 bold input-height-20">Instructors / Mentors:
                        <div class="margin-left-10" style="font-weight: normal" v-for="user in group.mentors">
                          <div class="margin-left-10">{{ user.name }}</div>
                        </div>
                      </div>
                      <div class="font-12 margin-left-10 bold input-height-20">Students / Mentees:

                        <div class="margin-left-10" style="font-weight: normal" v-for="mentee,mentee_index in group.mentees"  v-if="mentee_index <= 4">
                          <div class="margin-left-10">{{ mentee.name }}</div>
                        </div>
                        <b-collapse v-bind:id="'collapse-' + account_index + '-' + group_index" v-if="group.mentees.length > 5">
                          <div class="margin-left-10" style="font-weight: normal" v-for="mentee,mentee_index in group.mentees"  v-if="mentee_index > 4">
                            <div class="margin-left-10">{{ mentee.name }}</div>
                          </div>
                        </b-collapse>
                        <a class="font-12 cursor-pointer show_more_mentees" v-b-toggle="'collapse-' + account_index + '-' + group_index" v-if="group.mentees.length > 5">
                          <span class="when-opened">... less</span>
                          <span class="when-closed">... more</span>
                        </a>

                      </div>
                  </div>
                </div>
                <div style="clear: both;"></div>
                <b-collapse v-bind:id="'collapse-' + account_index" v-if="account.groups.length > 1">
                  <div class="group_class" v-for="group,group_index in account.groups" v-if="group_index > 0">
                    <div class="margin-left-10 "  >
                        <div class="font-12 bold input-height-20 group_name"><i class="fa fa-group"></i> Group: {{ group.group_name }}</div>
                        <div class="font-12 margin-left-10 bold input-height-20">Instructors / Mentors:
                          <div class="margin-left-10" style="font-weight: normal" v-for="user in group.mentors">
                            <div class="margin-left-10">{{ user.name }}</div>
                          </div>
                        </div>
                        <div class="font-12 margin-left-10 bold input-height-20">Students / Mentees:

                          <div class="margin-left-10" style="font-weight: normal" v-for="mentee,mentee_index in group.mentees"  v-if="mentee_index <= 4">
                            <div class="margin-left-10">{{ mentee.name }}</div>
                          </div>
                          <b-collapse v-bind:id="'collapse-' + account_index + '-' + group_index" v-if="group.mentees.length > 5">
                            <div class="margin-left-10" style="font-weight: normal" v-for="mentee,mentee_index in group.mentees"  v-if="mentee_index > 4">
                              <div class="margin-left-10">{{ mentee.name }}</div>
                            </div>
                          </b-collapse>
                          <a class="font-12 cursor-pointer show_more_mentees" v-b-toggle="'collapse-' + account_index + '-' + group_index" v-if="group.mentees.length > 5">
                            <span class="when-opened">... less</span>
                            <span class="when-closed">... more</span>
                          </a>

                        </div>
                    </div>
                  </div>
                </b-collapse>

                <div style="clear: both;"></div>
                <a class="font-12 cursor-pointer show_more" v-b-toggle="'collapse-' + account_index" v-if="account.groups.length > 1">
                  <span class="when-opened">Show less</span>
                  <span class="when-closed">Show more</span>
                </a>
                <div style="clear: both;"></div>
              </div>
            </div>
          </div>
          <div v-else class="col-xs-12 col-md-6 col-lg-4 col-xl-3 account_main_class padding-lr-5">
            No accounts found.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';

export default {
        data() {
          return {
            search: '',
            accounts: [],
          }
        },
        components: {
          UserMenu,
          GoBack,
          MasteradminSidebarMenu
        },
        methods: {
          getAccounts() {
             axios.get('/get_accounts_list', {

             })
             .then(response =>  {
                this.accounts = response.data.accounts;
             })
             .catch(function(error) {

             });
           },

        },
        computed:
        {
            userslist:function()
            {
            	 var self = this;
               return this.accounts.filter(function(cust){return cust.account_name.toLowerCase().indexOf(self.search.toLowerCase())>=0;});
            }
        },
        created: function() {
          this.getAccounts();
        }

    }



</script>

<style scoped>

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.account_class {
  width: 100%;
  border: 1px solid #8b8b8b;
  min-height: 300px;
  margin-bottom: 10px;
}
.account_main_class {
  float: none;
  display: inline-table;
  min-height: 300px;
}
.mentor-container {
  margin: 0px auto;
  width: 85%;
}
.group_class {
  width: 90%;
  float: left;
  margin-bottom: 25px;
}
@media(max-width:991px) {
  .mentor-container {
    margin: 0px auto;
    width: 90%;
    padding-top: 20px;
  }
  .group_class {
    width: 97%;
    float: left;
    margin-bottom: 25px;
  }
}
@media(max-width:768px) {
  .mentor-container {
    margin: 0px auto;
    width: 97%;
    padding-top: 20px;
  }
  .group_class {
    width: 90%;
    float: left;
    margin-bottom: 25px;
  }
  .account_main_class, .account_class {
    min-height: auto;
  }
}
.account_name {
  background-color: #8b8b8b;
  padding: 5px;
  color: #FFF;
  font-size: 14px;
}
.group_name {
  color: #338ED3;
}
a.show_more, a.show_more:focus {
  float: right;
  padding-bottom: 10px;
  color: #338ED3;
  padding-right: 5px;
}
a.show_more:hover {
  color: #000;
}
a.show_more_mentees {
  padding-bottom: 2px;
  color: #338ED3;
  font-weight: normal;
  padding-left: 20px;
}
.back-btn-wrapper {
  width: 100%;
  padding-left: 15px;
}
@media(max-width:560px) {
  .search-wrapper {
   margin-top: 62px;
  }
}
.search-wrapper {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/list_accounts.vue